<template>
  <v-container
    fluid
  >
    <v-dialog
      v-model="imageEdit.dialogOpen"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          Urejanje slike
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-text-field
              v-model="imageEdit.imageData.description"
              label="Opis slike"
            />
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            variant="text"
            @click="deleteImage"
          >
            Izbriši sliko
          </v-btn>
          <v-btn
            color="primary"
            variant="text"
            @click="imageEdit.dialogOpen = false"
          >
            Zapri
          </v-btn>
          <v-btn
            color="primary"
            variant="outlined"
            @click="updateImage()"
          >
            Shrani
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <material-lightbox
      :model-value="routeImageUrl"
      :images="lightboxImages"
      @close="setLightboxImage('')"
      @select="setLightboxImage"
    />

    <h2
      v-show="images.length > 0"
      class="text-title-large"
    >
      {{ humanReadableDate(date) }}
    </h2>
    <v-row>
      <v-col
        v-for="photo in images"
        :key="photo.image_id"
        cols="12"
        sm="6"
        md="4"
        class="d-flex"
      >
        <v-card
          class="mx-auto"
        >
          <v-card-text>
            <v-img
              :src="photo.thumbs[256][0]"
              aspect-ratio="1"
              class="bg-grey-lighten-2"
              @click="showLightbox(photo)"
            >
              <template #placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey-lighten-5"
                  />
                </v-row>
              </template>
            </v-img>
          </v-card-text>

          <v-card-actions v-if="canEditProject">
            <v-btn
              icon
              variant="text"
              aria-label="Uredi sliko"
              @click="openEditImageDialog(photo)"
            >
              <v-icon>edit</v-icon>
            </v-btn>

            <v-btn
              icon
              variant="text"
              aria-label="Prenesi sliko"
              @click="downloadImage(photo)"
            >
              <v-icon>download</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment';
import router from '@/router';
import MaterialLightbox from '@/views/components/MaterialLightbox';

export default {
  name: 'JournalImages',
  components: { MaterialLightbox },
  props: ['projectId', 'date', 'canEditProject', 'images'],
  data() {
    return {
      imageEdit: {
        dialogOpen    : false,
        dateDialogOpen: false,
        imageData     : {}
      },
    };
  },
  computed: {
    routeImageUrl() {
      return typeof this.$route.query.imageUrl === 'string' ? this.$route.query.imageUrl : '';
    },
    lightboxImages() {
      return this.images
          .map(i => {
            const humanReadableDate = moment(i.date).format('dddd, DD.MM.YYYY');

            return {
              name: i.thumbs[1024][0],
              alt : `${humanReadableDate}: ${i.description || 'Ni opisa'}`,
            };
          })
        ;
    },
  },
  methods: {
    humanReadableDate(date) {
      return moment(date).format('dddd, DD.MM.YYYY');
    },
    goTo(href) {
      if (this.$route.fullPath !== href) {
        router.push(href);
      }
    },
    showLightbox(image) {
      const imageUrl = image.thumbs[1024][0];
      this.setLightboxImage(imageUrl);
    },
    setLightboxImage(imageUrl) {
      const query = { ...this.$route.query };

      if (imageUrl) {
        query.imageUrl = imageUrl;
      } else {
        delete query.imageUrl;
      }

      router.push({ path: this.$route.path, query });
    },
    openEditImageDialog(image) {
      this.imageEdit.dialogOpen = true;
      this.imageEdit.imageData  = Object.assign({}, image);
    },
    downloadImage(image) {
      window.open(image.download_url, '_blank');
    },
    async updateImage() {
      this.imageEdit.dialogOpen = false;

      const projectId   = this.$route.params.projectId;
      const imageId     = this.imageEdit.imageData.image_id;
      const date        = this.imageEdit.imageData.date;
      const description = this.imageEdit.imageData.description;

      await this.$store.dispatch('updateSiteLogImage', {
        projectId,
        imageId,
        date,
        description
      });
    },
    async deleteImage() {
      this.imageEdit.dialogOpen = false;

      const projectId = this.$route.params.projectId;
      const imageId   = this.imageEdit.imageData.image_id;

      await this.$store.dispatch('deleteSiteLogImage', {
        projectId,
        imageId
      });
    },
  }
}
</script>
